import React, { useRef, useState } from "react";
import Section from "./common/Section";
import { socialDt } from "./data";
import Contacts from "../assets/mobile.png";
import emailjs from "emailjs-com";

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_kr00hhn",
        "template_tjr5m0k",
        formRef.current,
        "user_okjNVIUiZZzdPlrzjSyZz"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <Section title="Contact" subTilte="Lets discuss about projects">
      <div className="flex flex-col items-center gap-8 text-center">
        <div>
          <img src={Contacts} alt="Contact Info" className="w-32 h-32" />
        </div>
        <div>
          <p className="max-w-xs md:max-w-lg font-extralight">
            I'm open to talk regarding freelancing full-time opportunities. Feel
            free to contact me using your prefered medium.{" "}
          </p>
        </div>
        <div className="flex w-full items-center justify-evenly text-3xl">
          {socialDt.map((social) => (
            <a
              href={social.link}
              key={social.id}
              target="_blank"
              rel="noopener noreferrer"
              className="duration-200 ease-in-out hover:text-rose-200"
            >
              {social.icon}
            </a>
          ))}
        </div>

        <div className="p-8 text-left w-full">
          <form ref={formRef} onSubmit={handleOnSubmit}>
            <div className="gap-4 w-full">
              <div className="flex flex-col">
                <label className="capitalize text-sm py-2 font-extralight">
                  Name
                </label>
                <input
                  type="text"
                  name="user_name"
                  className="border-2 rounded-lg p-3 flex focus:outline-none border-gray-400 dark:bg-gray-900 dark:text-white"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label className="capitalize text-sm py-2 font-extralight">
                  Subject
                </label>
                <input
                  type="text"
                  name="user_subject"
                  className="border-2 rounded-lg p-3 flex focus:outline-none border-gray-400 dark:bg-gray-900 dark:text-white"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label className="capitalize text-sm py-2 font-extralight">
                  Email
                </label>
                <input
                  type="email"
                  name="user_email"
                  className="border-2 rounded-lg p-3 flex focus:outline-none border-gray-400 dark:bg-gray-900 dark:text-white"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label className="capitalize text-sm py-2 font-extralight">
                  Message
                </label>
                <textarea
                  type="text"
                  name="message"
                  rows="10"
                  className="border-2 rounded-lg p-3 flex focus:outline-none border-gray-400 dark:bg-gray-900 dark:text-white resize-none"
                  required
                ></textarea>
              </div>
            </div>
            <div className="flex items-center justify-center">
              <button className="my-8 bg-gradient-to-r from-rose-600 to-teal-500 text-white px-6 py-3 font-bold uppercase rounded-md tracking-wider cursor-pointer hover:scale-105 duration-200">
                📨 Send Message
              </button>
            </div>
          </form>
          {done && (
            <div
              class="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md"
              role="alert"
            >
              <div className="flex">
                <div className="py-1"></div>
                <div>
                  <p className="font-bold">
                    Thank you for your email, I'll get back to you as soon as
                    possible.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Section>
  );
};

export default Contact;
